import { Box, Button, Skeleton, Stack } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from "react-router"
import useSwr from "swr"
import { OrderApi } from "../../apis"
import { PageLayout } from "../../components/layout"
import { usePermission } from "../../components/permission"
import { ListState } from "../../components/ui"
import { SupplierSalesDetailForm } from "../../components/supplier-sales/detail-form"

/** Захиалгын дэлгэрэнгүй: ачаалж буй, алдаа (дахин оролдох), олдсонгүй, эрхгүй төлвүүдтэй (Ord_States). */
export function SupplierSalesDetail() {
  const params = useParams()
  const navigate = useNavigate()
  const { t } = useTranslation(["supplierSales", "common"])
  const ORD_SO_DETAIL = usePermission("ORD_SO_DETAIL")

  const { data, error, isLoading, mutate } = useSwr(
    ORD_SO_DETAIL.hasAccess ? `/ord/order/detail/get.${params.id}` : null,
    async () => await OrderApi.get(params.id as string),
  )

  const frame = (children: React.ReactNode) => (
    <PageLayout
      title={t("supplierSales:sales.orderDetail")}
      breadcrumb={[
        { to: "/", label: t("common:breadcrumb.home") },
        { to: "/supplier-sales", label: t("supplierSales:sales.orderList") },
        { label: t("supplierSales:sales.orderDetail") },
      ]}>
      <Box>{children}</Box>
    </PageLayout>
  )

  if (!ORD_SO_DETAIL.hasAccess) return frame(ORD_SO_DETAIL.accessDenied())

  if (isLoading && !data) {
    return frame(
      <Stack gap="md">
        <Skeleton height={96} radius="lg" />
        <Skeleton height={180} radius="lg" />
        <Skeleton height={260} radius="lg" />
      </Stack>,
    )
  }

  const status = (error as { statusCode?: number } | undefined)?.statusCode
  if (status === 404 || (!error && !data)) {
    return frame(
      <ListState
        state="empty"
        title={t("supplierSales:detail.notFoundTitle")}
        description={t("supplierSales:detail.notFoundText")}
        action={{ label: t("supplierSales:detail.back"), onClick: () => navigate("/supplier-sales") }}
      />,
    )
  }
  if (error) {
    return frame(
      <Stack gap="md" align="flex-start">
        <ListState state="error" onRetry={() => mutate()} errorCode={status} />
        <Button variant="default" onClick={() => navigate("/supplier-sales")}>{t("supplierSales:detail.back")}</Button>
      </Stack>,
    )
  }

  return <SupplierSalesDetailForm action={["detail", data]} reload={mutate} />
}
